/*
helper function to pass to the style of components to hide them

<div style={hideIfTrue(this.props.hidden)}/>
 */
export default function hideIfTrue(condition) {
    return condition ? { display: "none" } : {}
}
